import React, { useEffect, useRef, useState } from "react";
import { Field, useFormik, Form, Formik } from "formik";
import * as Yup from "yup";
import { FormattedMessage, injectIntl } from "react-intl";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import DefineAdditionalFee from "../DefineFeeOnAddStudent";
import ReactSelect from "react-select";
import { baseUrl } from "../../../../services/config";
import { Link, useHistory } from "react-router-dom";
import {
  Input,
  DatePickerField,
  Select,
} from "../../../../_metronic/_partials/controls";
import { useAlert } from "react-alert";
import CustomSelect from "./CustomSelect";
import { empty } from "object-path";
import { id } from "date-fns/locale";
import MaskedInput from "react-text-mask";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import PrintChallan from "./PrintChallan";
import { DatePicker, Space } from "antd";
import { Toaster, toast } from "react-hot-toast";
import ReciveFeeModal from "./ReciveFeeModal";

const { RangePicker } = DatePicker;
const cnicNumberMask = [
  /[1-9]/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
];

function AddStudent({ onClose, show }) {
  let today = new Date();
  today.setDate(today.getDate() + 2);
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();
  let tod = yyyy + "-" + mm + "-" + dd;

  let today1 = new Date();
  today1.setDate(today1.getDate());
  let dd1 = String(today1.getDate()).padStart(2, "0");
  let mm1 = String(today1.getMonth() + 1).padStart(2, "0");
  let yyyy1 = today1.getFullYear();
  let currentData = yyyy1 + "-" + mm1 + "-" + dd1;

  const getCurrentMonthYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11, so add 1
    return `${year}-${month}`;
  };

  //new changes in student register form
  const user = useSelector((state) => state.user.user);
  const [empEnable, setempEnable] = useState(false);
  const [studentfoefeegenerate, setstudentfoefeegenerate] = useState({});
  const [defineadditionalfeeshow, setdefineadditionalfeeshow] = useState(false);
  const [allsessions, setallsessions] = useState([]);
  const [allenablefields, setallenablefields] = useState("");
  const [
    isalladmissionfeeEnablefields,
    setisalladmissionfeeEnablefields,
  ] = useState(false);
  const [studentmodal, setstudentmodal] = useState(true);
  const [selectedStudent, setselectedStudent] = useState([]);
  const [selectedStudentId, setselectedStudentId] = useState(0);
  const history = useHistory();
  const alert = useAlert();
  const [isformsubmitted, setisformsubmitted] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const [hostelIDs, setHostelIDs] = useState([]);
  const [vehicleIDs, setVehicleIDs] = useState([]);
  const [concession, setconcession] = useState([]);
  const [paymentType, setPaymentType] = useState([]);
  const [previousSchoolData, setPreviousSchoolData] = useState([]);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [directfeemodal, setdirectfeemodal] = useState(false);
  const [directstudentobject, setdirectstudentobject] = useState({});
  const [directfeeEnable, setdirectfeeEnable] = useState(false);
  const [due_date, setdue_date] = useState("");
  const [issue_date, setissue_date] = useState("");
  const [regloading, setregloading] = useState(false);
  const [feetypeamount, setfeetypeamount] = useState("");
  const [studentAddMessage, setstudentAddMessage] = useState(false);
  const [anyconcesstion, setanyconcesstion] = useState("");
  const [anyPaymentType, setAnyPaymentType] = useState("");
  const [anyvehicle, setanyvehicle] = useState("");
  const [anyhostel, setanyhostel] = useState("");
  const [prevSchool, setPrevSchool] = useState("");

  const [monthlyFeeInputsvalue, setmonthlyFeeInputsvalue] = useState([]);
  const [printModel, setPrintModel] = useState(false);
  const authtoken = localStorage.getItem("userToken");

  const [errorcreate, seterrorcreate] = useState("Please fill all fields");
  const [isallfields, setisallfields] = useState(false);
  const [inServiceEmpList, setinServiceEmpList] = useState([]);
  const [selectedsession, setselectedsession] = useState("");
  const [selectedEmpId, setselectedEmpId] = useState("");
  const [feemontherror, setfeemontherror] = useState(false);
  const [selectedConcType, setselectedConcType] = useState("");
  const [selectedEductionType, setselectedEductionType] = useState(1);
  const [reciveFeeModal, setReciveFeeModal] = useState(false);
  const dispatch = useDispatch();
  const [indirectaddmissionmodal, setindirectaddmissionmodal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [admissionFeeOnStart, setAdmissionFeeOnStart] = useState([]);
  const [receivableAmounts, setReceivableAmounts] = useState([]);
  const [totalFee, setTotalFee] = useState(0);
  const [receivableFee, setReceivableFee] = useState(0);
  const [receivableAmountError, setReceivableAmountError] = useState(false);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);
  const [allSections, setAllSections] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");

  useEffect(() => {
    getAllSessions();
    getconcession();
    getEmpList();
    getHostelID();
    getVehicleID();
    getPaymentType();
    getPreviousSchool();
  }, []);

  const getEmpList = () => {
    fetch(`${baseUrl}/employees_all_campus`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify({
        job_status_id: "1",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setinServiceEmpList(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setallsessions(data.payload);

            data.payload.map((session, index) => {
              if (session.active_academic_year == "1") {
                setselectedsession(session.id);
              }
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);

    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    setCourseClassData([]);
    setClassSectionData([]);

    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    setClassSectionData([]);
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getHostelID = async () => {
    await fetch(`${baseUrl}/hostel`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setHostelIDs(data.payload);
      })
      .catch((err) => {
        console.log("hostel", err);
      });
  };

  const getVehicleID = async () => {
    await fetch(`${baseUrl}/vehicle`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setVehicleIDs(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getconcession = async () => {
    await fetch(`${baseUrl}/concession`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setconcession(data.payload);
      })
      .catch((err) => {
        console.log("concession", err);
      });
  };

  const getPaymentType = async () => {
    await fetch(`${baseUrl}/payment-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setPaymentType(data.payload);
      })
      .catch((err) => {
        console.log("paymentType", err);
      });
  };

  const getPreviousSchool = async () => {
    await fetch(`${baseUrl}/previous-school`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setPreviousSchoolData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const handleAmountChange = (index, event) => {
    const { value } = event.target;

    // Convert value to number using parseFloat or parseInt
    const parsedValue = parseFloat(value); // or parseInt(value, 10) for integer

    // Create a new array with updated value
    const updatedReceivableAmounts = [...receivableAmounts];
    updatedReceivableAmounts[index] = {
      ...updatedReceivableAmounts[index],
      amount_after_concession: parsedValue,
    };

    let actualamount = updatedReceivableAmounts[index].amount;

    if (actualamount < parsedValue) {
      setReceivableAmountError(true);
      toast.error("Receiving Amount is Greater than Net Amount");
    } else {
      setReceivableAmountError(false);
    }

    let initialReceiveableFee = 0;
    updatedReceivableAmounts.map((item) => {
      initialReceiveableFee += parseInt(item.amount_after_concession);
    });
    setReceivableFee(initialReceiveableFee);

    // Update the state
    setReceivableAmounts(updatedReceivableAmounts);
  };

  const getAdmissionFeeOnStart = (
    selectedsession,
    campusId,
    courseId,
    classId,
    paymentType,
    installments,
    concession_slab,
    anyhostel,
    anyvehicle,
    isfeemonth
  ) => {
    const data = {
      year_id: selectedsession,
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      payment_type: paymentType,
      installments: installments == "" ? null : installments,
      concession: concession_slab == "" ? 0 : concession_slab,
      hostel_id: anyhostel == "" ? null : anyhostel,
      vehicle_id: anyvehicle == "" ? null : anyvehicle,
      is_direct_admission: isfeemonth,
    };

    fetch(`${baseUrl}/admissionFeesOnStart`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setAdmissionFeeOnStart(data.payload);

        if (data.payload && data.payload.length > 0) {
          const initialAmounts = data.payload.map((feeOnStart) => ({
            fee_type_id: feeOnStart.fee_type_id,
            amount: feeOnStart.net_amount,
            amount_after_concession: feeOnStart.amount,
          }));

          let initialNetFee = 0;
          data.payload.map((item) => {
            initialNetFee += parseInt(item.net_amount);
          });

          let initialTotalFee = 0;
          data.payload.map((item) => {
            initialTotalFee += parseInt(item.amount);
          });

          // Update the state variable with the filtered values
          setTotalFee(initialNetFee);
          setReceivableFee(initialTotalFee);
          setReceivableAmounts(initialAmounts);
        } else {
          setTotalFee(0);
          setReceivableFee(0);
        }
      })
      .catch((err) => {
        console.log("campuses", err);
      });
  };

  function convertToArray(singleFeeMonth) {
    if (Array.isArray(singleFeeMonth)) {
      return singleFeeMonth;
    }
    try {
      return JSON.parse(singleFeeMonth);
    } catch (e) {
      return singleFeeMonth.split(",").map((item) => item.trim());
    }
  }

  const initialValues = {
    name: "",
    father_name: "",
    dob: "",
    religion: "Islam",
    gender: "",
    course_id: "",
    campus_id: "",
    class_id: "",
    payment_type: "",
    installments: "",
    section_id: "",
    mobile_no: "",
    concession_remarks: "",
    concession_slab: "",
    address: "",
    remarks: "",
    class_left: "",
    leaving_date: "",
    shift: "1st",
    cnic_no: "",
    father_cnic: "",
    phone: "",
    fee_months: yyyy + "-" + mm,
    isfeemonth: false,
    is_leading: false,
    no_fee_admission: false,
    fee_due_date: tod,
    fee_issue_date: currentData,
    single_fee_month: getCurrentMonthYear(),
    year_id: selectedsession,
  };

  const createEroors = (
    errors,
    touched,
    isSubmitting,
    values,
    setValues,
    setSubmitting
  ) => {
    setisallfields(false);

    if (errors.name && touched.name) {
      seterrorcreate(errors.name);
      setisallfields(true);
      return;
    }

    if (errors.father_name && touched.father_name) {
      seterrorcreate(errors.father_name);
      setisallfields(true);
      return;
    }
    if (errors.year_id && touched.year_id) {
      seterrorcreate(errors.year_id);
      setisallfields(true);
      return;
    }

    if (errors.religion && touched.religion) {
      seterrorcreate(errors.religion);
      setisallfields(true);
      return;
    }

    if (errors.dob && touched.dob) {
      seterrorcreate(errors.dob);
      setisallfields(true);
      return;
    }

    if (errors.gender && touched.gender) {
      seterrorcreate(errors.gender);
      setisallfields(true);
      return;
    }

    if (errors.campus_id && touched.campus_id) {
      seterrorcreate(errors.campus_id);
      setisallfields(true);
      return;
    }

    if (errors.course_id && touched.course_id) {
      seterrorcreate(errors.course_id);
      setisallfields(true);
      return;
    }

    if (errors.class_id && touched.class_id) {
      seterrorcreate(errors.class_id);
      setisallfields(true);
      return;
    }

    if (errors.section_id && touched.section_id) {
      seterrorcreate(errors.section_id);
      setisallfields(true);
      return;
    }

    if (errors.address && touched.address) {
      seterrorcreate(errors.address);
      setisallfields(true);
      return;
    }

    if (errors.payment_type && touched.payment_type) {
      seterrorcreate(errors.payment_type);
      setisallfields(true);
      return;
    }

    if (errors.installments && touched.installments) {
      seterrorcreate(errors.installments);
      setisallfields(true);
      return;
    }
    // if (errors.leaving_date && touched.leaving_date) {
    //   seterrorcreate(errors.leaving_date)
    //   setisallfields(true)
    //   return;
    // }
    // if (errors.shift && touched.shift) {
    //   seterrorcreate(errors.shift)
    //   setisallfields(true)
    //   return;
    // }

    // if (errors.remarks && touched.remarks) {
    //   seterrorcreate(errors.remarks)
    //   setisallfields(true)
    //   return;
    // }

    // if (errors.previous_school && touched.previous_school) {
    //   seterrorcreate(errors.previous_school);
    //   setisallfields(true);
    //   return;
    // }
    // if (errors.class_left && touched.class_left) {
    //   seterrorcreate(errors.class_left)
    //   setisallfields(true)
    //   return;
    // }

    if (errors.cnic_no && touched.cnic_no) {
      seterrorcreate(errors.cnic_no);
      setisallfields(true);
      return;
    }
    if (errors.father_cnic && touched.father_cnic) {
      seterrorcreate(errors.father_cnic);
      setisallfields(true);
      return;
    }
    if (errors.mobile_no && touched.mobile_no) {
      seterrorcreate(errors.mobile_no);
      setisallfields(true);
      return;
    }

    if (errors.concession_remarks && touched.concession_remarks) {
      seterrorcreate(errors.concession_remarks);
      setisallfields(true);
      return;
    }
    if (errors.concession_slab && touched.concession_slab) {
      seterrorcreate(errors.concession_slab);
      setisallfields(true);
      return;
    }

    if (errors.phone && touched.phone) {
      seterrorcreate(errors.phone);
      setisallfields(true);
      return;
    }
    // if (feemontherror) {
    //   seterrorcreate("Fee Month is required");
    //   setisallfields(true);
    //   return;
    // }
    if (errors.fee_due_date && touched.fee_due_date) {
      seterrorcreate(errors.fee_due_date);
      setisallfields(true);
      return;
    }

    if (errors.fee_issue_date && touched.fee_issue_date) {
      seterrorcreate(errors.fee_issue_date);
      setisallfields(true);
      return;
    }

    if (errors.single_fee_month && touched.single_fee_month) {
      seterrorcreate(errors.single_fee_month);
      setisallfields(true);
      return;
    }

    if (errors.fee_months && touched.fee_months) {
      seterrorcreate(errors.fee_months);
      setisallfields(true);
      return;
    }

    if (Object.keys(errors).length === 0) {
      if (values.name == "") {
      } else {
        if (isSubmitting) {
          setSubmitting(false);
          if (!isformsubmitted) {
            setisformsubmitted(true);
            AddStudentHandler(values, setValues);
            setValues(values);
          }
        }
      }
    }
  };

  const StudentRegistrationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),

    father_name: Yup.string().required("Father name is required"),
    // year_id: Yup.string().required("Session is required"),

    dob: Yup.string().notRequired("Date Of Birth required field"),

    religion: Yup.string().required("Religion is required field"),
    gender: Yup.string().required("Gender Is Required"),
    // concession_id: Yup.number()
    //   .notRequired('field must be a number'),

    // hostel_id: Yup.number()
    //   .notRequired('field must be a number'),

    mobile_no: Yup.string()
      .required("Mobile Number required field")
      .matches(
        /^(3)([0-9]{9})$/,
        "Mobile Number  Must start with 3 and must have 13 digits"
      ),

    // address: Yup.string().required("Address Is Required"),

    remarks: Yup.string().notRequired("Remarks required field"),

    // previous_school: Yup.string().notRequired("last School is required field"),

    class_left: Yup.string().notRequired("Class Left required field"),

    leaving_date: Yup.string().notRequired("Leaving Date required field"),

    // vehicle_id: Yup.number()
    //   .notRequired('required field'),

    shift: Yup.string().required("Shift is required!"),

    cnic_no: Yup.string()
      .notRequired("Cnic No required field")
      .matches(
        /^[0-9]{5}-[0-9]{7}-[0-9]$/,
        "CNIC No must follow the XXXXX-XXXXXXX-X format!"
      ),

    class_id: Yup.string().required("Class Is Required"),
    // // medium:Yup.string()
    // // .ensure()
    // // .required(" required!"),

    payment_type: Yup.string().required("Payment Type Is required"),
    installments:
      anyPaymentType != "1"
        ? Yup.string().notRequired("Installment Is required")
        : Yup.string().required("Installment Is required"),

    course_id: Yup.string().required("Course Is required"),
    campus_id: Yup.string().required("Campus Is required"),
    section_id: Yup.string().required("Section Is required"),

    father_cnic: Yup.string()
      .required("Father Cnic required field")
      // .notRequired("Father Cnic required field")
      .matches(
        /^[0-9]{5}-[0-9]{7}-[0-9]$/,
        "CNIC No must follow the XXXXX-XXXXXXX-X format!"
      ),

    phone: Yup.string()
      .notRequired("phone required field")
      .matches(
        /^(3)([0-9]{9})$/,
        "landline Number  Must start with 3 and must have 13 digits"
      ),
    isfeemonth: Yup.boolean(),

    is_leading: Yup.boolean(),

    fee_months:
      anyPaymentType != "1"
        ? Yup.string().when("isfeemonth", {
            is: true,
            then: Yup.string().notRequired("Fee Month required"),
          })
        : Yup.string().when("isfeemonth", {
            is: true,
            then: Yup.string().required("Fee Month required"),
          }),

    fee_due_date: Yup.string().when("isfeemonth", {
      is: true,
      then: Yup.string().required("Due Date required"),
    }),

    fee_issue_date: Yup.string().when("isfeemonth", {
      is: true,
      then: Yup.string().required("Issue Date required"),
    }),

    single_fee_month:
      anyPaymentType != "1"
        ? Yup.string().when("isfeemonth", {
            is: false,
            then: Yup.string().notRequired("Fee Month required"),
          })
        : Yup.string().when("isfeemonth", {
            is: false,
            then: Yup.string().required("Fee Month required"),
          }),

    concession_remarks:
      anyconcesstion != ""
        ? Yup.string().required("Concession Remarks is required")
        : Yup.string()
            .notRequired()
            .nullable(),

    concession_slab:
      anyconcesstion != ""
        ? Yup.number().required("Concession Slab is required")
        : Yup.number()
            .notRequired()
            .nullable(),
    // otherwise: Yup.string().notRequired()

    // applied_for: Yup.string()
    //   .required('required field'),
  });

  const AddStudentHandler = async (values, setValues) => {
    if (values.isfeemonth && values.payment_type != "1") {
      if (monthlyFeeInputsvalue.length == 0) {
        setfeemontherror(true);
        setisformsubmitted(false);
        return;
      }
    }

    setLoading(true);

    const fdata = {
      name: values.name,
      father_name: values.father_name,
      religion: values.religion,
      gender: values.gender,
      campus_id: values.campus_id,

      address: values.address,
      remarks: values.remarks,
      previous_school_id: prevSchool,
      class_left: values.class_left,
      shift: values.shift,
      student_class_id: values.class_id,
      global_section_id: values.section_id,

      course_id: values.course_id,
      payment_type: values.payment_type,
      installments: values.installments,
      status: values.isfeemonth ? 2 : 1,

      is_direct_admission: values.isfeemonth ? 2 : 1,
      is_leading_classes: values.is_leading ? 1 : 0,
      no_fee_admission: values.no_fee_admission ? 1 : 0,

      leaving_date: values.leaving_date,
      dob: values.dob,

      cnic_no: values.cnic_no,
      father_cnic: values.father_cnic,

      concession_id: anyconcesstion,
      hostel_id: anyhostel,
      mobile_no: "92" + values.mobile_no,
      phone: "92" + values.phone,

      vehicle_id: anyvehicle,
      admission_id: 123,

      fee_months: values.isfeemonth
        ? monthlyFeeInputsvalue
        : convertToArray(values.single_fee_month + "-01"),
      due_date: values.fee_due_date,
      issue_date: values.isfeemonth ? null : values.fee_issue_date,

      employee_id: selectedEmpId,
      year_id: selectedsession,
      fee_amounts: receivableAmounts,
      concession_remarks:
        anyconcesstion != "" ? values.concession_remarks : null,
      concession: anyconcesstion != "" ? values.concession_slab : 0,
    };

    await fetch(`${baseUrl}/student`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(fdata),
    })
      .then((res) => res.json())
      .then((data) => {
        setValues(values);
        setdirectfeeEnable(false);
        setdirectfeemodal(false);
        setLoading(false);
        if (data.metadata) {
          if (data.metadata.success) {
            setstudentAddMessage(true);
            setstudentmodal(false);
            searchStudent(data.payload.registration_id);

            if (values.isfeemonth && values.is_leading != 1) {
              if (data.payload.admission_id != null) {
                searchStudent(data.payload.registration_id);
                alert.show(
                  `Student Added Successfully and admission id is ${data.payload.admission_id}`,
                  { timeout: 0 }
                );
                setstudentAddMessage(false);
                setPrintModel(false);
                history.push("/active-students");
              } else {
                searchStudent(data.payload.registration_id);
                setPrintModel(true);
                alert.show(
                  `Student Added Successfully and registration id is ${data.payload.registration_id}`,
                  { timeout: 0 }
                );
              }
            } else {
              searchStudent(data.payload.registration_id);
              alert.show(
                `Student Added Successfully and registration id is ${data.payload.registration_id}`,
                { timeout: 0 }
              );
              history.push("/leading-class-students");
              indirectaddmissionmodal(false);
              setstudentAddMessage(false);
            }

            setisformsubmitted(false);
            if (!values.isfeemonth) {
              // searchStudent(data.payload.registration_id);
              // setindirectaddmissionmodal(true);
              // getRespectivefee(
              //   data.payload.campus_id,
              //   data.payload.student_class_id,
              //   selectedsession
              // );

              searchStudent(data.payload.registration_id);
              setPrintModel(true);
              alert.show(
                `Student Added Successfully and registration id is ${data.payload.registration_id}`,
                { timeout: 0 }
              );
            }

            setstudentfoefeegenerate(data.payload);
            setdirectstudentobject(data.payload);
            alert.show("Student Added successfully");
            // if (onClose == undefined) {
            //   history.push('/student')
            // } else {

            //   onClose()
            // }
            // getRespectivefee(values.campus_id, values.class_id);

            // if (data.metadata.success) {

            //   if (directadmission == 'on') {
            //     setLoading(false)
            //     setregisenable(false)

            //     setisformsubmitted(false)
            //   } else {

            //     setLoading(false)
            //     setadmissionfeeEnable(true)
            //     setregisenable(false)
            //     setdirectfeeEnable(false)
            //     setisformsubmitted(false)
            //     //history.push('/student')
            //   }

            // }
          } else {
            // alert.show("Something Went Wrong 1");
            setLoading(false);

            if (onClose == undefined) {
              history.push("/other-students");
            } else {
              onClose();
            }
            setisformsubmitted(false);
          }
        } else {
          // alert.show("Something Went Wrong 2");
          setLoading(false);
          if (onClose == undefined) {
            history.push("/other-students");
          } else {
            onClose();
          }
          setisformsubmitted(false);
        }
      })
      .catch((err) => {
        // alert.show("Something Went Wrong 3");
        setLoading(false);
        setisformsubmitted(false);
        if (onClose == undefined) {
          history.push("/other-students");
        } else {
          onClose();
        }
      });
  };

  const genrateRegisterFee = () => {
    let res = isdirectaddmissionenablefields();
    if (!res) {
      return;
    }
    setregloading(true);

    if (due_date.length != 0) {
      if (issue_date.length != 0) {
        let fees_type_id = [];
        let amount = [];
        amount[0] = feetypeamount;
        fees_type_id[0] = 2;

        const data = {
          monthly_fee_status: 0,
          additional_fee_status: 1,
          fees_type_id,
          amount,
          fee_months: [],
          due_date,
          issue_date,
        };

        fetch(`${baseUrl}/custom_fees_generate/${directstudentobject.id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${authtoken}`,
          },
          body: JSON.stringify(data),
        })
          .then((res) => {
            res.json().then((data) => {
              setregloading(false);
              setdue_date("");
              setissue_date("");

              if (data.metadata) {
                if (data.metadata.success) {
                  setindirectaddmissionmodal(false);
                  setregloading(false);
                  alert.show("Fee generated successfully");
                  // history.push("/student");
                  setPrintModel(true);
                  onClose();
                } else {
                  setregloading(false);

                  alert.show(data.message);
                }
              } else {
                setregloading(false);

                alert.show(data.message);
              }
            });
          })
          .catch((err) => {
            console.log(err);
            setdue_date("");
            setissue_date("");
            setregloading(false);
            setdirectfeemodal(false);
            alert.show(err);
          });
      } else {
        setregloading(false);

        alert.show("Please enter due date");
      }
    } else {
      setregloading(false);
      alert.show("Please enter due date");
    }
  };

  const shiftoption = [
    { value: "1st", label: "1st" },
    { value: "2nd", label: "2nd" },
  ];

  const concessionoption = [];
  concessionoption[0] = { value: "", label: "Select ..." };
  concession.map((item, index) => {
    concessionoption[index + 1] = { value: item.id, label: item.name };
  });

  const empOptions = [];
  empOptions[0] = { value: "", label: "Select ..." };
  inServiceEmpList.map((item, index) => {
    empOptions[index + 1] = {
      value: item.id,
      label: `${
        item.full_name.length > 15
          ? item.full_name.substr(0, 10)
          : item.full_name
      }-${item.emp_code}`,
    };
  });

  const vehicleoption = [];
  vehicleoption[0] = { value: "", label: "Select ..." };
  vehicleIDs.map((item, index) => {
    vehicleoption[index + 1] = { value: item.id, label: item.model };
  });

  const hosteloptions = [];
  hosteloptions[0] = { value: "", label: "Select ..." };
  hostelIDs.map((item, index) => {
    hosteloptions[index + 1] = { value: item.id, label: item.name };
  });

  const schooloptions = [];
  schooloptions[0] = { value: "", label: "Select ..." };
  previousSchoolData.map((item, index) => {
    schooloptions[index + 1] = { value: item.id, label: item.name };
  });

  function isdirectaddmissionenablefields() {
    if (due_date == "") {
      setisalladmissionfeeEnablefields(true);
      setallenablefields("Please add due date");
      return false;
    }
    if (issue_date == "") {
      setisalladmissionfeeEnablefields(true);
      setallenablefields("Please add issue date");
      return false;
    }
    return true;
  }

  const onChangeGetEmployeList = (event) => {
    setselectedEmpId(event.value);
  };

  const handlePrintOff = () => {
    setPrintModel(false);
    history.push("/other-students");
  };

  /////here we go

  const searchStudent = (id) => {
    const data = {
      admission_id: "",
      registration_id: id,
    };

    fetch(`${baseUrl}/student_chllan_by_admission_id`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setselectedStudent(data.payload.students);
          setselectedStudentId(data.payload.students[0]?.id);
        } else {
        }
      })
      .catch((err) => {
        console.log("error in searchstudent", err);
      });
  };

  const handleConcession = (evt) => {
    setanyconcesstion(evt.value);
  };

  const handleChanger = (day, date) => {
    setfeemontherror(false);
    let startDate = date[0] + "-01";
    let endDate = date[1] + "-01";
    var start = startDate.split("-");
    var end = endDate.split("-");
    var startYear = parseInt(start[0]);
    var endYear = parseInt(end[0]);
    var dates = [];

    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
      for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        var month = j + 1;
        var displayMonth = month < 10 ? "0" + month : month;
        dates.push([i, displayMonth, "01"].join("-"));
      }
    }
    setmonthlyFeeInputsvalue(dates);
  };

  return (
    <>
      <Modal
        size="xl"
        show={show}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Toaster />
        {studentAddMessage ? (
          <>
            <Alert
              variant="success"
              onClose={() => setstudentAddMessage(false)}
              dismissible
            >
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "bolder",
                  fontSize: "2rem",
                }}
              >
                Student Added Successfully and registration id is{" "}
                {studentfoefeegenerate.registration_id}{" "}
              </p>
            </Alert>
          </>
        ) : null}
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            {indirectaddmissionmodal ? <>Define Fee </> : <>Add new Student</>}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {studentmodal ? (
            <div className="">
              <div className="">
                {/* <div className="generate text-center">Enter Student Detail and Submit</div> */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="login-form login-signin"
                        style={{ display: "block" }}
                      >
                        {loading ? (
                          <b style={{ color: "green" }}>
                            {" "}
                            Adding Please Wait {` `}{" "}
                            <span className="spinner-border"></span>
                          </b>
                        ) : (
                          <Formik
                            enableReinitialize={false}
                            initialValues={initialValues}
                            validationSchema={StudentRegistrationSchema}
                            onSubmit={(values) => {
                              // AddStudentHandler(values);
                            }}
                          >
                            {(props) => {
                              const {
                                handleSubmit,
                                errors,
                                touched,
                                values,
                                setSubmitting,
                                isSubmitting,
                                isValid,
                                setValues,
                                handleChange,
                                handleBlur,
                              } = props;

                              createEroors(
                                errors,
                                touched,
                                isSubmitting,
                                values,
                                setValues,
                                setSubmitting
                              );

                              return (
                                <>
                                  <Form
                                    onSubmit={handleSubmit}
                                    className="form form-label-right"
                                  >
                                    <div className="switch mb-6">
                                      <label
                                        className="mr-12"
                                        style={{
                                          display: "flex",
                                          flexDirection: "row-reverse",
                                        }}
                                      >
                                        <span style={{ paddingTop: "10px" }}>
                                          {" "}
                                          Direct Admission
                                        </span>

                                        <Field
                                          name="isfeemonth"
                                          component={Input}
                                          type="checkbox"
                                        />
                                        <span className="lever"></span>
                                      </label>

                                      <label
                                        style={{
                                          display: "flex",
                                          flexDirection: "row-reverse",
                                        }}
                                      >
                                        <span style={{ paddingTop: "10px" }}>
                                          {" "}
                                          Leading Class Admission
                                        </span>

                                        <Field
                                          name="is_leading"
                                          component={Input}
                                          type="checkbox"
                                        />
                                        <span className="lever"></span>
                                      </label>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>
                                          Name{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>

                                        <Field
                                          name="name"
                                          component={Input}
                                          placeholder="First Name"
                                          maxLength={120}
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label>
                                          Father Name{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <Field
                                          maxLength={120}
                                          name="father_name"
                                          component={Input}
                                          placeholder="Enter Father Name"
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label>
                                          Session{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <select
                                          className="form-select form-control"
                                          name="year_id"
                                          value={selectedsession}
                                          onChange={(e) =>
                                            setselectedsession(e.target.value)
                                          }
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Session
                                          </option>
                                          {allsessions.map((item, index) => (
                                            <option key={index} value={item.id}>
                                              {item.year}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.year_id && touched.year_id && (
                                          <div
                                            style={{ color: "#f87d8a" }}
                                            className="input-feedback"
                                          >
                                            {errors.year_id}
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-3">
                                        <label>
                                          Campus{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <select
                                          className="form-select form-control"
                                          name="campus_id"
                                          value={values.campus_id}
                                          onChange={(e) => {
                                            handleChange(e); // Call the handleChange from Formik
                                            onCampusChange(e.target.value); // Call the handleChange)
                                          }}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Campus
                                          </option>
                                          {campuses.map((item, index) => (
                                            <option key={index} value={item.id}>
                                              {item.name}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.campus_id && touched.campus_id && (
                                          <div
                                            style={{ color: "#f87d8a" }}
                                            className="input-feedback"
                                          >
                                            {errors.campus_id}
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-3">
                                        <label>
                                          Course{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>

                                        <select
                                          className="form-select form-control"
                                          name="course_id"
                                          value={values.course_id}
                                          onChange={(e) => {
                                            handleChange(e); // Call the handleChange from Formik
                                            onCourseChange(e.target.value); // Call the handleChange)
                                          }}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Course
                                          </option>
                                          {campusCourseData.map(
                                            (item, index) => (
                                              <option
                                                key={index}
                                                value={item.course?.id}
                                              >
                                                {item.course?.name}
                                              </option>
                                            )
                                          )}
                                        </select>
                                        {errors.course_id && touched.course_id && (
                                          <div
                                            style={{ color: "#f87d8a" }}
                                            className="input-feedback"
                                          >
                                            {errors.course_id}
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-3">
                                        <label>
                                          Class{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>

                                        <select
                                          className="form-select form-control"
                                          name="class_id"
                                          value={values.class_id}
                                          onChange={(e) => {
                                            handleChange(e); // Call the handleChange from Formik
                                            onClassChange(e.target.value); // Call the handleChange)
                                          }}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">Select Class</option>
                                          {courseClassData.map(
                                            (item, index) => (
                                              <option
                                                key={index}
                                                value={item.class?.id}
                                              >
                                                {item.class?.name}
                                              </option>
                                            )
                                          )}
                                        </select>
                                        {errors.class_id && touched.class_id && (
                                          <div
                                            style={{ color: "#f87d8a" }}
                                            className="input-feedback"
                                          >
                                            {errors.class_id}
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-3">
                                        <label>
                                          Section{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <select
                                          className="form-select form-control"
                                          name="section_id"
                                          value={values.section_id}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Section
                                          </option>
                                          {classSectionData.map(
                                            (item, index) => (
                                              <option
                                                key={index}
                                                value={item.section?.id}
                                              >
                                                {item.section?.name}
                                              </option>
                                            )
                                          )}
                                        </select>
                                        {errors.section_id &&
                                          touched.section_id && (
                                            <div
                                              style={{ color: "#f87d8a" }}
                                              className="input-feedback"
                                            >
                                              {errors.section_id}
                                            </div>
                                          )}
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>
                                          Religion{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>

                                        <Field
                                          name="religion"
                                          maxLength={120}
                                          component={Input}
                                          placeholder="Enter Religion"
                                        />
                                      </div>

                                      <div className="col-lg-4">
                                        <label>Date of Birth</label>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                        <Field
                                          name="dob"
                                          type="date"
                                          max="9999-11-30"
                                          component={Input}
                                        />
                                      </div>

                                      <div className="col-lg-4">
                                        <label>
                                          Gender{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>

                                        <select
                                          className="form-select"
                                          name="gender"
                                          value={values.gender}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          style={{
                                            backgroundColor: "white",
                                            height: 40,
                                          }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Gender
                                          </option>
                                          <option value="Male">Male</option>
                                          <option value="Female">Female</option>
                                          <option value="Other">Other</option>
                                        </select>
                                        {errors.gender && touched.gender && (
                                          <div
                                            style={{ color: "#f87d8a" }}
                                            className="input-feedback"
                                          >
                                            {errors.gender}
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>Payment Type </label>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                        <select
                                          className="form-select form-control"
                                          name="payment_type"
                                          value={values.payment_type}
                                          onChange={(e) => {
                                            handleChange(e);
                                            setAnyPaymentType(e.target.value);
                                            getAdmissionFeeOnStart(
                                              selectedsession,
                                              values.campus_id,
                                              values.course_id,
                                              values.class_id,
                                              e.target.value,
                                              values.installments,
                                              values.concession_slab,
                                              anyhostel,
                                              anyvehicle,
                                              values.isfeemonth
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Payment Type
                                          </option>
                                          {paymentType.map((item, index) => (
                                            <option key={index} value={item.id}>
                                              {item.name}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.payment_type &&
                                          touched.payment_type && (
                                            <div
                                              style={{ color: "#f87d8a" }}
                                              className="input-feedback"
                                            >
                                              {errors.payment_type}
                                            </div>
                                          )}
                                      </div>

                                      <div className="col-lg-4">
                                        <label>Installments</label>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                        <select
                                          disabled={
                                            !(values.payment_type == "1")
                                          }
                                          className="form-select form-control"
                                          name="installments"
                                          value={values.installments}
                                          onChange={(e) => {
                                            handleChange(e);
                                            getAdmissionFeeOnStart(
                                              selectedsession,
                                              values.campus_id,
                                              values.course_id,
                                              values.class_id,
                                              values.payment_type,
                                              e.target.value,
                                              values.concession_slab,
                                              anyhostel,
                                              anyvehicle,
                                              values.isfeemonth
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          <option value="">
                                            Select Installment
                                          </option>
                                          <option value="1">
                                            One Installment
                                          </option>
                                          <option value="2">
                                            Two Installments
                                          </option>
                                          <option value="3">
                                            Three Installments
                                          </option>
                                          <option value="4">
                                            Four Installments
                                          </option>
                                        </select>
                                        {errors.installments &&
                                          touched.installments && (
                                            <div
                                              style={{ color: "#f87d8a" }}
                                              className="input-feedback"
                                            >
                                              {errors.installments}
                                            </div>
                                          )}
                                      </div>

                                      <div className="col-lg-4">
                                        <label>Employee </label>
                                        <div className="input">
                                          <ReactSelect
                                            isDisabled={
                                              empEnable ? false : true
                                            }
                                            className="input"
                                            onChange={(evt) => {
                                              onChangeGetEmployeList(evt);
                                            }}
                                            placeholder="Select Employee"
                                            options={empOptions}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>Concession </label>

                                        <CustomSelect
                                          required
                                          className="input"
                                          onChange={(evt) => {
                                            handleConcession(evt);
                                            setanyconcesstion(evt.value);
                                            if (evt.value == "2") {
                                              setempEnable(true);
                                            } else {
                                              setempEnable(false);
                                            }
                                          }}
                                          placeholder="Select Concession"
                                          options={concessionoption}
                                        />
                                      </div>
                                      {/* {anyconcesstion != "" && ( */}
                                      <div className="col-lg-4">
                                        <label>Concession Remarks </label>

                                        <Field
                                          name="concession_remarks"
                                          component={Input}
                                          placeholder="Concession Remarks"
                                          required
                                          type="text"
                                          disabled={!(anyconcesstion != "")}
                                        />
                                      </div>
                                      {/* )} */}
                                      {/* {anyconcesstion != "" && ( */}
                                      <div className="col-lg-4">
                                        <label>Concession Slab (%) </label>

                                        <Field
                                          name="concession_slab"
                                          component={Input}
                                          onChange={(e) => {
                                            handleChange(e);
                                            getAdmissionFeeOnStart(
                                              selectedsession,
                                              values.campus_id,
                                              values.course_id,
                                              values.class_id,
                                              values.payment_type,
                                              values.installments,
                                              e.target.value,
                                              anyhostel,
                                              anyvehicle,
                                              values.isfeemonth
                                            );
                                          }}
                                          placeholder="1-100 %"
                                          type="number"
                                          disabled={!(anyconcesstion != "")}
                                          required
                                        />
                                      </div>
                                      {/* )} */}
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>Hostel </label>
                                        <CustomSelect
                                          className="input"
                                          onChange={(e) => {
                                            setanyhostel(e.value);
                                            getAdmissionFeeOnStart(
                                              selectedsession,
                                              values.campus_id,
                                              values.course_id,
                                              values.class_id,
                                              values.payment_type,
                                              values.installments,
                                              values.concession_slab,
                                              e.value,
                                              anyvehicle,
                                              values.isfeemonth
                                            );
                                          }}
                                          placeholder="Select Hostel"
                                          options={hosteloptions}
                                        />
                                      </div>

                                      <div className="col-lg-4">
                                        <label>Address </label>
                                        <Field
                                          name="address"
                                          component={Input}
                                          placeholder="Enter Your Address"
                                          maxLength={120}
                                          //  label="Address"
                                          // customFeedbackLabel='Enter Your Area Name City Street '
                                        />
                                      </div>

                                      <div className="col-lg-4">
                                        <label>Vehicle </label>
                                        <CustomSelect
                                          required
                                          className="input"
                                          onChange={(evt) => {
                                            setanyvehicle(evt.value);
                                            getAdmissionFeeOnStart(
                                              selectedsession,
                                              values.campus_id,
                                              values.course_id,
                                              values.class_id,
                                              values.payment_type,
                                              values.installments,
                                              values.concession_slab,
                                              anyhostel,
                                              evt.value,
                                              values.isfeemonth
                                            );
                                          }}
                                          placeholder="Select Vehicle"
                                          options={vehicleoption}
                                        />
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>CNIC/B-Form </label>
                                        <Field
                                          name="cnic_no"
                                          render={({ field }) => (
                                            <MaskedInput
                                              {...field}
                                              mask={cnicNumberMask}
                                              id="cnic_no"
                                              placeholder="Enter Your CNIC / B-Form No"
                                              type="text"
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              // className="is-invalid form-control"
                                              className={
                                                errors.cnic_no &&
                                                touched.cnic_no
                                                  ? "is-invalid form-control"
                                                  : "form-control"
                                              }
                                            />
                                          )}
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label>Shift </label>

                                        <select
                                          className="form-select form-control"
                                          name="shift"
                                          value={values.shift}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          style={{ backgroundColor: "white" }}
                                          aria-label="Default select example"
                                        >
                                          {shiftoption.map((item, index) => (
                                            <option
                                              key={index}
                                              value={item.value}
                                            >
                                              {item.label}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.shift && touched.shift && (
                                          <div
                                            style={{ color: "#f87d8a" }}
                                            className="input-feedback"
                                          >
                                            {errors.shift}
                                          </div>
                                        )}

                                        {/* <CustomSelect

                                          className='input'
                                          onChange={evt => {

                                            setshiftselect(evt.value)
                                            // if (shiftselect == "") {
                                            //   setisshiftselect(true)
                                            // } else {
                                            //   setisshiftselect(false)

                                            // }


                                          }}
                                          placeholder="Select shift"
                                          options={shiftoption}
                                        />
                                        {isshiftselect ? <div style={{
                                          color: "#F64E60", fontSize: "0.9rem",
                                          fontWeight: "400"
                                        }} className='error'>Shift is Required</div> : null} */}
                                      </div>

                                      <div className="col-lg-4">
                                        <label>Father CNIC </label>{" "}
                                        <span style={{ color: "red" }}>*</span>
                                        <Field
                                          name="father_cnic"
                                          render={({ field }) => (
                                            <MaskedInput
                                              {...field}
                                              mask={cnicNumberMask}
                                              id="father_cnic"
                                              placeholder="Enter Your Father CNIC"
                                              type="text"
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              // className="is-invalid form-control"
                                              className={
                                                errors.father_cnic &&
                                                touched.father_cnic
                                                  ? "is-invalid form-control"
                                                  : "form-control"
                                              }
                                            />
                                          )}
                                        />
                                        {/* <Field
                                            maxLength={15}
                                            name="father_cnic"
                                            // pattern={/^0[1-9]|[1-9]\d$/}
                                            required
                                            component={Input}
                                            type="text"
                                            placeholder="Enter Your Father CNIC"
                                          // label="Father CNIC"
                                          /> */}
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <div className="col-lg-4">
                                        <label>Remarks </label>

                                        <Field
                                          name="remarks"
                                          component={Input}
                                          maxLength={120}
                                          placeholder="remarks"
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label>Landline Number </label>

                                        <Field
                                          maxLength={10}
                                          required
                                          name="phone"
                                          component={Input}
                                          type="text"
                                          placeholder="Enter Your Phone/LandLine No"
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label>
                                          Mobile Phone Number{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <Field
                                          maxLength={10}
                                          required
                                          name="mobile_no"
                                          type="text"
                                          component={Input}
                                          placeholder="Enter Your Smart Phone No"
                                        />
                                      </div>
                                    </div>

                                    {values.isfeemonth ? (
                                      <>
                                        <div className="generate text-center">
                                          Fee Details
                                        </div>
                                        <br />
                                        <br />

                                        <div className="row">
                                          <div className="col-md-3 text-center">
                                            <label
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Fee Name
                                            </label>
                                          </div>
                                          <div className="col-md-3 text-center">
                                            <label
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Amount
                                            </label>
                                          </div>
                                          <div className="form-group col-md-3 flex-column d-flex text-center">
                                            <label
                                              className="form-control-label"
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Concession
                                            </label>
                                          </div>
                                          <div className="form-group col-md-3 flex-column d-flex text-center">
                                            <label
                                              className="form-control-label"
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Receiving Amount
                                            </label>
                                          </div>
                                        </div>

                                        {/* All Fee Details with Input Field */}
                                        {admissionFeeOnStart &&
                                          admissionFeeOnStart.map(
                                            (feeOnStart, index) => (
                                              <div
                                                className="row"
                                                key={feeOnStart.fee_type_id}
                                              >
                                                <div className="col-md-3">
                                                  <select
                                                    className="form-select form-control"
                                                    name="fee_type"
                                                    style={{
                                                      backgroundColor: "white",
                                                    }}
                                                    aria-label="Default select example"
                                                    value={
                                                      feeOnStart.fee_type_id
                                                    }
                                                    disabled
                                                  >
                                                    <option
                                                      value={
                                                        feeOnStart.fee_type_id
                                                      }
                                                    >
                                                      {feeOnStart.fee_name}
                                                    </option>
                                                  </select>
                                                </div>
                                                <div className="col-md-3">
                                                  <input
                                                    className="form-control"
                                                    type="number"
                                                    value={
                                                      feeOnStart.net_amount
                                                    }
                                                    disabled
                                                  />
                                                </div>
                                                <div className="form-group col-md-3 flex-column d-flex">
                                                  <span
                                                    style={{
                                                      marginTop: "15px",
                                                    }}
                                                    disabled
                                                  >
                                                    Concession Applied{" "}
                                                    {feeOnStart?.concession_allowed !=
                                                    null
                                                      ? feeOnStart?.concession_allowed
                                                      : 0}
                                                  </span>
                                                </div>
                                                <div className="form-group col-md-3 flex-column d-flex">
                                                  <input
                                                    className="mt-3"
                                                    min={1}
                                                    value={
                                                      receivableAmounts[index]
                                                        ?.amount_after_concession ||
                                                      0
                                                    }
                                                    type="number"
                                                    onChange={(e) =>
                                                      handleAmountChange(
                                                        index,
                                                        e
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            )
                                          )}

                                        {/* Net Fee & Receiving Fee */}
                                        <div className="row">
                                          <div className="col-md-6 d-flex">
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Net Fee:-
                                            </p>
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "bold",
                                                marginLeft: "30px",
                                              }}
                                            >
                                              {parseInt(totalFee)}
                                            </p>
                                          </div>

                                          <div className="col-md-6 d-flex">
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Receiving Fee:-
                                            </p>
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "bold",
                                                marginLeft: "30px",
                                              }}
                                            >
                                              {parseInt(receivableFee)}
                                            </p>
                                          </div>
                                        </div>
                                      </>
                                    ) : null}

                                    <div className="generate text-center mt-3">
                                      Previous School Detail
                                    </div>
                                    <br />
                                    <br />

                                    <div className="row">
                                      <div className="col-lg-4">
                                        <label>Class Left </label>
                                        <Field
                                          maxLength={120}
                                          name="class_left"
                                          component={Input}
                                          placeholder="Enter Student Class left"
                                          // label="Class Left"
                                        />
                                      </div>

                                      <div className="col-lg-4">
                                        <label>
                                          Previous School{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <CustomSelect
                                          required
                                          className="input"
                                          onChange={(evt) => {
                                            setPrevSchool(evt.value);
                                          }}
                                          placeholder="Select School"
                                          options={schooloptions}
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label>Leaving Date </label>
                                        <Field
                                          name="leaving_date"
                                          component={Input}
                                          type="date"
                                          max="9999-11-30"
                                          // customFeedbackLabel='Enter Last School Leave Date'
                                        />
                                      </div>
                                    </div>

                                    {!values.is_leading &&
                                      (values.isfeemonth &&
                                      !(values.payment_type == "1") ? (
                                        <div className="form-group row">
                                          <div className="col-lg-4">
                                            <label>Fee Months</label>

                                            <RangePicker
                                              name="fee_months"
                                              getPopupContainer={(
                                                triggerNode
                                              ) => {
                                                return triggerNode.parentNode;
                                              }}
                                              style={{ height: "40px" }}
                                              picker="month"
                                              onChange={(day, date) =>
                                                handleChanger(day, date)
                                              }
                                            />
                                            {feemontherror ? (
                                              <label className="text-danger">
                                                Fee Month is required
                                              </label>
                                            ) : (
                                              ""
                                            )}
                                          </div>

                                          <div className="col-lg-4">
                                            <label>Due Date</label>
                                            <Field
                                              name="fee_due_date"
                                              component={Input}
                                              type="date"
                                              max="9999-11-30"
                                              // customFeedbackLabel='Enter Last School Leave Date'
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="form-group row">
                                          <div className="col-lg-4">
                                            <label className="form-control-label">
                                              Due Date
                                            </label>

                                            <Field
                                              name="fee_due_date"
                                              component={Input}
                                              type="date"
                                              max="9999-11-30"
                                            />
                                          </div>
                                          <div className="col-lg-4">
                                            <label className="form-control-label">
                                              Issue Date{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </label>

                                            <Field
                                              name="fee_issue_date"
                                              component={Input}
                                              type="date"
                                              max="9999-11-30"
                                            />
                                          </div>
                                          {!(values.payment_type == "1") ? (
                                            <div className="col-lg-4">
                                              <label className="form-control-label">
                                                Fee Month{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>

                                              <Field
                                                name="single_fee_month"
                                                component={Input}
                                                type="month"
                                                max="9999-11-30"
                                              />
                                            </div>
                                          ) : null}
                                        </div>
                                      ))}
                                  </Form>

                                  {isallfields ? (
                                    <>
                                      <Alert
                                        variant="danger"
                                        onClose={() => setisallfields(false)}
                                        dismissible
                                      >
                                        <Alert.Heading>
                                          Oh snap! You got an error!
                                        </Alert.Heading>
                                        <p>{errorcreate}</p>
                                      </Alert>
                                    </>
                                  ) : null}

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    {values.isfeemonth ? (
                                      <div className="mt-4 mr-4">
                                        <Field
                                          type="checkbox"
                                          name="no_fee_admission"
                                          id="no_fee_admission"
                                        />
                                        <label
                                          for="no_fee_admission"
                                          className="form-control-label"
                                        >
                                          <b>Admit Without Fee Receiving</b>
                                        </label>
                                      </div>
                                    ) : null}

                                    <button
                                      className="btn btn-success button_blue"
                                      disabled={receivableAmountError}
                                      onClick={() => {
                                        handleSubmit();
                                      }}
                                      type="submit"
                                      value="Submit"
                                    >
                                      {loading ? (
                                        <span className="spinner-border"></span>
                                      ) : (
                                        <>Submit</>
                                      )}
                                    </button>

                                    <button
                                      onClick={() => {
                                        setisallfields(false);
                                        if (onClose == undefined) {
                                          history.push("/other-students");
                                        } else {
                                          onClose();
                                        }
                                      }}
                                      className="btn btn-danger btn_width ml-3"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </>
                              );
                            }}
                          </Formik>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {indirectaddmissionmodal ? (
            <>
              <div className="row d-flex m-10">
                <div></div>
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                  {/* form start from here */}
                  {/* <div className="generate text-center">Generate Registration Fee</div> */}
                  {/*            
                  <h3 className="generate">Generate Registration Fee</h3> */}
                  <form className="form-card">
                    <div className="row">
                      <div className="form-group col-sm-12">
                        <div className="row">
                          <div className="col-sm-6">
                            <label>
                              <b>
                                Student Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </b>
                            </label>
                            <input
                              style={{ backgroundColor: "#F3F6F9" }}
                              disabled
                              defaultValue={directstudentobject.name}
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <div className="col-sm-6">
                            <label>
                              <b>
                                Registration ID{" "}
                                <span style={{ color: "red" }}>*</span>
                              </b>
                            </label>
                            <input
                              style={{ backgroundColor: "#F3F6F9" }}
                              disabled
                              defaultValue={directstudentobject.registration_id}
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="row mt-5">
                          <div className="col-sm-12">
                            <label>
                              <b>
                                Father Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </b>
                            </label>
                            <input
                              disabled
                              defaultValue={directstudentobject.father_name}
                              style={{ backgroundColor: "#F3F6F9" }}
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="form-group col-sm-6 flex-column d-flex">



                               </div> */}
                      <div className="form-group col-sm-6 flex-column d-flex pt-3">
                        <label className="form-control-label">
                          <b>
                            Fee type <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <select
                          className="form-select form-control"
                          style={{ backgroundColor: "#F3F6F9" }}
                          aria-label="Default select example"
                        >
                          <option value="">REGISTRATION</option>
                        </select>
                      </div>

                      <div className="form-group col-sm-6 flex-column d-flex pt-3">
                        <label className="form-control-label">
                          <b>
                            Amount <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          disabled
                          defaultValue={feetypeamount}
                          style={{ backgroundColor: "#F3F6F9" }}
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div>
                      <h5>Fee Detail </h5>
                    </div>
                    <div className="row justify-content-between text-left">
                      <div className="form-group col-sm-6 flex-column d-flex">
                        <label className="form-control-label">
                          <b>
                            Due Date <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          format="DD/MM/YYYY"
                          onChange={(e) => setdue_date(e.target.value)}
                          type="date"
                          max="9999-11-30"
                          className="form-control  mb-2"
                        />

                        <label className="form-control-label">
                          <b>
                            Issue Date <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          format="DD/MM/YYYY"
                          onChange={(e) => setissue_date(e.target.value)}
                          type="date"
                          max="9999-11-30"
                          className="form-control  mb-2"
                        />
                      </div>
                    </div>
                  </form>
                </div>

                {isalladmissionfeeEnablefields ? (
                  <>
                    <Alert
                      variant="danger"
                      onClose={() => setisalladmissionfeeEnablefields(false)}
                      dismissible
                    >
                      <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                      <p>{allenablefields}</p>
                    </Alert>
                  </>
                ) : null}

                <div
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  className=""
                >
                  <button
                    onClick={genrateRegisterFee}
                    className="btn btn-success button_blue "
                  >
                    Generate
                    {/* Generate Register Fee */}
                    {regloading && (
                      <span className="ml-3 spinner spinner-white"></span>
                    )}
                  </button>

                  <button
                    onClick={() => {
                      setdeleteModal(true);
                    }}
                    style={{ marginLeft: "15px" }}
                    className="btn btn-danger btn_width "
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </Modal.Body>

        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure you want to Cancel this?
            </Modal.Title>
          </Modal.Header>
          {/* 
        <Modal.Body>

          <> Are you sure you want to Cancel this?</>

        </Modal.Body> */}
          <Modal.Footer>
            <button
              onClick={() => {
                setdeleteModal(false);
                if (onClose == undefined) {
                  history.push("/other-students");
                } else {
                  onClose();
                }
              }}
              className="btn btn-success button_blue"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setdeleteModal(false);
                setdue_date("");
                setissue_date("");
                setindirectaddmissionmodal(false);
                setstudentmodal(true);
              }}
              className="btn btn-danger btn_width"
            >
              Back
            </button>
          </Modal.Footer>
        </Modal>

        {defineadditionalfeeshow ? (
          <DefineAdditionalFee
            studentdetail={studentfoefeegenerate}
            show={defineadditionalfeeshow}
            proceed={"proceed"}
            issue_date={issue_date}
            due_date={due_date}
          />
        ) : null}
      </Modal>

      {printModel ? (
        <PrintChallan
          show={printModel}
          close={handlePrintOff}
          selectedStudent={selectedStudent}
          selectedStudentId={selectedStudentId}
        />
      ) : null}
    </>
  );
}

export default AddStudent;
